import React, { useEffect, useState } from 'react'
import {
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core'
import { sortBy } from 'lodash'
import { tableColumnOne } from 'src/utils/constants/RiskCategory'

const CUT_OFF_LENGTH = 5
const TO_LAKHS = 100000

const TrendAnalysis = ({ title, data }) => {
  const classes = useStyles()
  const [dataList, setDataList] = useState([])

  useEffect(() => {
    if (data) {
      const d = sortBy(data, ['year'])?.reverse()
      const firlstFive = d?.slice(0, CUT_OFF_LENGTH)?.reverse()
      formatTableData(firlstFive)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [data])

  const formatTableData = (d) => {
    const fd = d?.map((obj) => {
      return Object.assign({}, obj, {
        turnOver: formatAmount(obj?.turnOver),
        totalPremium: formatAmount(obj?.totalPremium),
        totalClaims: formatAmount(obj?.totalClaims),
        claimsRatio:
          obj?.claimsRatio !== null
            ? `${Number(obj?.claimsRatio?.toFixed(2))} %`
            : '-',
      })
    })
    setDataList(fd?.reverse())
  }

  const formatAmount = (amt) => {
    if (!amt || amt === 0) return '0'

    const a = Number((amt / TO_LAKHS)?.toFixed(2))
    let formattedAmount = ''

    if (a >= 100) {
      formattedAmount = `${a > 0 ? a / 100 : 0} C`
    } else {
      formattedAmount = `${a} L`
    }
    return formattedAmount
  }

  const tableHeadings = dataList?.map((e) => e?.year)

  const renderInnerTable = (value) => {
    return dataList?.map((t, i) => {
      return <div key={`tc-${i}`}>{t?.[value]}</div>
    })
  }
  return (
    <>
      <div className={classes.root}>
        <h2 className={classes.title}>{title}</h2>
        <div className={classes.matrixTable}>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell width='50'></TableCell>
                  <>
                    {tableHeadings?.map((th) => (
                      <TableCell key={`tableHeading_${th?.value}`}>
                        {th}
                      </TableCell>
                    ))}
                  </>
                </TableRow>
              </TableHead>
              <TableBody>
                <>
                  {tableColumnOne?.map((row) => (
                    <TableRow
                      key={`tableColumn_${row?.value}`}
                      className={classes.tableRowStyles}
                    >
                      <TableCell component='td' scope='row'>
                        <div className={`label ${classes.label}`}>
                          {row?.label}
                        </div>
                      </TableCell>
                      <TableCell colSpan={5}>
                        <div className={classes.colSpanWrapper}>
                          {renderInnerTable(row?.value)}
                        </div>
                      </TableCell>
                    </TableRow>
                  ))}
                </>
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </div>
    </>
  )
}

export default TrendAnalysis

const useStyles = makeStyles({
  root: {
    height: '100%',
    maxHeight: '100%',
    overflow: 'auto',
  },
  title: {
    fontSize: '18px',
    lineHeight: '22px',
    marginTop: '20px',
    padding: '0px 24px 5px 24px',
    textAlign: 'center',
    color: '#333333',
    fontWeight: '600',
  },
  matrixTable: {
    padding: '5px 15px 0px 15px',
    '& .MuiTableCell-root': {
      padding: 0,
      border: 0,
      textAlign: 'center',
    },
    '& .MuiTable-root': {
      marginBottom: '15px',
    },
    '& tbody': {
      '& tr:last-child': {
        '& div': {
          borderBottom: '1px solid rgba(224, 224, 224, 1)',
          '&.label': {
            border: 0,
          },
        },
      },
    },
  },
  colSpanWrapper: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    borderTop: '1px solid rgba(224, 224, 224, 1)',
    '& > div': {
      padding: '8px',
      fontSize: '12.5px',
      borderLeft: '1px solid rgba(224, 224, 224, 1)',
      width: '50px',
      color: '#333333',
      height: '16px',
      overflow: 'hidden',
      textOverflow: 'ellipsis',
    },
  },
  tableRowStyles: {
    '&:last-child td, &:last-child th': {
      border: 0,
    },
  },
  label: {
    color: '#B92250',
    padding: '0px 5px',
    fontSize: '13px',
  },
})
